import { render, staticRenderFns } from "./CultureAssetRegisterInfo.vue?vue&type=template&id=7dcf5866&scoped=true&"
import script from "./CultureAssetRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./CultureAssetRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf5866",
  null
  
)

export default component.exports